import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Grid,
  Button,
  TextField,
  Typography,
  Stepper,
  Step,
  StepLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  Checkbox,
  FormGroup,
  InputAdornment,
} from "@mui/material";
import {
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  StepConnector,
} from "@mui/material";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import AuthHeader from "../../../Auth";
import UnLock from "../../../GlobalFunction/UnLock";
import { Category } from "@mui/icons-material";
import axiosInstance from "../../../lib/axios";
import CustomAutocomplete from "../../../Components/AutoComplete/AutoComplete";
import AddIcon from "@mui/icons-material/Add";

const PartyStepper1 = ({
  AllButtonTextDisabled,
  setAllButtonTextDisabled,
  Mode,
  PartyRetrieveData,
  setMode,
  fetchPartyData,
  handleToNextClick,
  setPartyRetrieveData,
  SiteByData,
  setSiteByData,
  setGridData,
  MainData,
  Company,
  PartyId,
  UserId,
  Category,
  Status,
  setStatus,
}) => {
  const { register, watch, reset, setFocus, setValue } = useForm();
  const [PinCity, setPinCity] = useState([]);
  const [RdUrd, setRdUrd] = useState("1");
  const [MsmeFlag, setMsmeFlag] = useState("N");
  const [ClassDrp, setClassDrp] = useState([]);
  const [RatingDrp, setRatingDrp] = useState([]);
  const [localStatus, setLocalStatus] = useState("1");

  console.log("hii", watch());

  const openNewTab = () => {
    window.open("/pincode");
  };

  useEffect(() => {
    //  handlePinIdChange();
    if (Mode === "view" && PinCity.length > 0) {
      handlePinIdChange();
    }
  }, [PinCity]);

  useEffect(() => {
    console.log("Mode  DataArr", Mode, SiteByData);
    console.log("Mode  PartyRetrieveData", Mode, PartyRetrieveData);

    if (PartyRetrieveData.length > 0 && Mode === "view") {
      console.log(watch());
      const obj = watch();
      // for (let key in obj) {
      //     setValue(key, PartyRetrieveData[0][key]);
      // }
      // setValue("RdUrd","1");
      // setValue("Pincode","410206");
      // setValue("PinId",516789);
      // settingValue();
      setValueFunc(obj, [...PartyRetrieveData]);
    } else if (Mode === "view") {
      fetchPartyData(1, "L", Category);
    } else if (SiteByData.length > 0 && Mode === "add") {
      setValueFunc(watch(), [...SiteByData]);
    } else {
      resetFunc();
    }
  }, [PartyRetrieveData, Mode, SiteByData]);

  const settingValue = () => {
    handlePincodeChange();
  };

  const setValueFunc = (obj, Arr) => {
    for (let key in obj) {
      setValue(key, Arr[0][key]);
    }

    setRdUrd(Arr[0]["RdUrd"]);
    setMsmeFlag(Arr[0]["MsmeFlag"]);

    // setValue("Pincode","410206");
    // setValue("PinId",516789);
    settingValue();
  };

  const resetFunc = () => {
    console.log(watch());

    reset({
      PartyName: "",
      RdUrd: "",
      PartyAltCode: "",
      PartyAbrv: "",
      PartyCat: "",
      AccledId: 1,
      PinId: "",
      PinCode: "",
      Addr: "",
      GsttinNo: "",
      PanNo: "",
      TanNo: "",
      IeCode: "",
      TelNo: "",
      Email: "",
      ContactPerson: "",
      MobileNo: "",
      WorkAdd: "",
      MsmeFlag: "",
      MsmeNo: "",
      MsmeAct: "N",
      MsmeTr: "N",
      MsmeClass: "N",
      Remark: "",
      VndClsId: 1,
      VndRtgId: 1,
    });
    setRdUrd("1");
    setMsmeFlag("N");
    setLocalStatus("1");
  };

  useEffect(() => {
    const statusFromForm = watch("Status");
    if (statusFromForm) {
      setLocalStatus(statusFromForm);
    }
  }, [watch]);

  const handlePincodeChange = async () => {
    if (watch("PinCode") === undefined || watch("PinCode") === "") return;
    let value = watch("PinCode");
    console.log("value", value);
    if (value.trim().length === 6) {
      try {
        const response = await axiosInstance.post(
          `pincodeMst/getdrppincodewisearea`,
          {
            PinCode: parseInt(value),
          }
        );
        const data = response.data.Data;

        if (data && data.length > 0) {
          setPinCity(data);
        } else {
          setPinCity([]);
        }
      } catch (error) {
        console.error("Error fetching pin code data:", error);
      }
    } else {
      setValue("City", "");
      setValue("State", "");
      setPinCity([]);
    }
  };

  const handlePinIdChange = async () => {
    console.log("PinId", watch("PinId"));
    if (watch("PinId") === undefined || watch("PinId") === "") return;
    let getObj = PinCity.find((obj) => obj.Id === watch("PinId"));
    console.log("getobj ", getObj);
    let AreaName = getObj?.Name;
    let PinCode = getObj?.PinCode;
    if (getObj) {
      try {
        const response = await axiosInstance.post(
          `pincodeMst/getdrppincodeAreawise_datafill`,
          {
            AreaName,
            PinCode,
          }
        );
        const data = response.data.Data;
        console.log("pindata", data);
        if (data && data.length > 0) {
          setValue("City", data[0].CityName);
          setValue("State", data[0].StateName);
        } else {
        }
      } catch (error) {
        console.error("Error fetching pin code data:", error);
      }
    }
  };

  const missingFields = [
    { key: "PartyName", name: "Party Name" },
    { key: "PartyAbrv", name: "Party Abbreviation" },
    { key: "PartyCat", name: "Party Type" },
    { key: "PinCode", name: "Pincode" },
    { key: "PinId", name: "Area" },
  ];

  const handleClickNext = () => {
    // if (watch('PartyName') === "" || watch("PartyAbrv") === "" || watch("PartyCat") === "" || watch("PinCode") === "" || watch("PinId") === "" || watch("RdUrd") === "") {
    //     console.log("ok fortoast")
    //     if (!toast.isActive(13, "friendRequest1")) {

    //         toast("First Filled The Required Field", {
    //             position: "top-right",
    //             autoClose: true,
    //             closeOnClick: true,
    //             draggable: false,
    //             type: "error",
    //             toastId: 13
    //         });

    //     }
    //     return;

    const firstMissing = missingFields.find((field) => watch(field.key) === "");

    if (firstMissing) {
      console.log("ok fortoast");

      if (!toast.isActive(13, "friendRequest1")) {
        toast(`${firstMissing.name} is required`, {
          position: "top-right",
          autoClose: true,
          closeOnClick: true,
          draggable: false,
          type: "error",
          toastId: 13,
        });
      }

      return;
    } else {
      //   let DataArr = [...PartyRetrieveData]
      //   for(let key in watch()){
      //     DataArr[0][key] = watch(key);
      //   }
      // console.log("DataArr,Mode",Mode , DataArr);
      // //   Mode === "view" && setPartyRetrieveData(DataArr);
      //   Mode === "add" && setSiteByData(DataArr);
      // //
      console.log("watch of watch", watch());

      if (RdUrd === "1" || RdUrd === "3") {
        if (watch("GsttinNo") === "") {
          toast.info("Gst Field Is Required");
          return;
        }
      }

      if (Mode === "add") {
        let arr = [watch()];
        console.log("arr", arr);
        arr[0].MsmeFlag = MsmeFlag;
        arr[0].RdUrd = RdUrd;
        setSiteByData(arr);

        console.log(Status);
        setValue("Status", Status);
      } else {
        let data = [...PartyRetrieveData];
        let obj = watch();
        for (let key in obj) {
          data[0][key] = obj[key];
        }
        data[0]["MsmeFlag"] = MsmeFlag;
        data[0]["RdUrd"] = RdUrd;
        console.log("data", data);
        setValue("Status", Status);
        setPartyRetrieveData(data);
      }
      let TakeForwardObj = watch();
      let ind = PinCity.findIndex((item) => item.Id === watch("PinId"));
      TakeForwardObj.AreaName = PinCity[ind]?.Name;
      TakeForwardObj.RdUrd = RdUrd;
      console.log(TakeForwardObj);
      handleToNextClick(TakeForwardObj);
    }
  };

  useEffect(() => {
    if (Status) {
      setLocalStatus(Status);
    }
  }, [Status]);

  const handleClickCancel = async () => {
    if (PartyId != -1 && Mode === "view") {
      // try {
      //     let response = await axios.post(
      //         `${process.env.REACT_APP_API_URL}Lock/UpdateLock`,
      //         {
      //             "tblName": "MstParty",
      //             "LockSt": "0",
      //             "LockId": UserId,
      //             "Cwhere": "PartyId",
      //             "LockDt": "2024-11-27 17:30:01.743",
      //             "DocId": PartyId,
      //             "Flag": "",
      //             "ColName": "LockSt",
      //             "ColName1": "LockId",
      //             "ColName2": "LockDt"
      //         },
      //         AuthHeader()
      //     );

      //     if (response.data.Status === 0) {

      //         // setMode("view");
      //         // setAllButtonTextDisabled(prev => !prev);
      //         // toast.info(response.data.Message);

      //     }

      // }

      // catch (err) {
      //     console.log("err", err);
      // }

      let Flag = await UnLock(PartyId, "MstParty", "PartyId");
      console.log(Flag);
      switch (Flag) {
        case 0:
          break;
        case 1:
          toast.info("Problem To Unlocked Record", { autoClose: 500 });
          break;
        default:
          toast.info("Something Went Wrong", { autoClose: 500 });
      }
    }

    setAllButtonTextDisabled(false);
    setMode("view");
    setSiteByData([]);
    if (MainData.length > 0) setGridData(MainData[0].PartyMstDtlList);
  };

  const handleUrdChange = (e) => {
    setValue("RdUrd", e.target.value);
    console.log(watch("RdUrd"));
    setRdUrd(e.target.value);
  };

  const handleClickFlag = (e) => {
    console.log("hii hello ", watch("MsmeFlag"));
    console.log(e.target.value);
    setValue("MsmeFlag", e.target.value);
    setMsmeFlag(e.target.value);
    if (e.target.value === "N") {
      setValue("MsmeAct", "N");
      setValue("MsmeTr", "N");
      setValue("MsmeClass", "N");
    } else {
      setValue("MsmeAct", "");
      setValue("MsmeTr", "");
      setValue("MsmeClass", "");
    }
  };

  useEffect(() => {
    fetchClassData();
    fetchRatingData();
  }, []);

  const fetchClassData = async () => {
    const Flag = "";
    try {
      const response = await axiosInstance.post(
        `MstVendClass/GetMstVndClsdrp`,
        { Flag }
      );

      if (response.data.Status === 0) {
        setClassDrp(response.data.Data);
        // setValue("VndClsId", response.data.Data[0].Id);
        // setValue("Name", response.data.Data[0].Name);
      } else {
        toast.error("Error fetching class data");
      }
    } catch (error) {
      toast.error("Error fetching class data");
    }
  };

  const fetchRatingData = async () => {
    const Flag = "";
    try {
      const response = await axiosInstance.post(
        `MstVendRating/GetMstVndRtgdrp`,
        { Flag }
      );

      if (response.data.Status === 0) {
        setRatingDrp(response.data.Data);
        // setValue("VndClsId", response.data.Data[0].Id);
        // setValue("Name", response.data.Data[0].Name);
      } else {
        toast.error("Error fetching rating data");
      }
    } catch (error) {
      toast.error("Error fetching rating data");
    }
  };

  const handleChangeStatus = (e) => {
    let status = e.target.checked ? "1" : "0";
    setLocalStatus(status);
    setStatus(status);
    setValue("Status", status);
    console.log("statuscheck", status);
  };

  return (
    <>
      {/* <ToastContainer /> */}
      <Grid container spacing={2}>
        <Grid container spacing={1}>
          <Grid item lg={8} md={8} xs={12}>
            <Box display="flex" flexDirection="column" gap={0.5}>
              <Grid item lg={12} md={12} xs={12}>
                <Box display="flex" flexDirection="column" gap={2}>
                  <Grid container spacing={0.5}>
                    <Grid item xs={12} md={8}>
                      <TextField
                        fullWidth
                        label={
                          <span>
                            Party Name <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        value={watch("PartyName") || ""}
                        name="PartyName"
                        variant="filled"
                        className="custom-textfield"
                        disabled={!AllButtonTextDisabled}
                        {...register("PartyName")}
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <Grid
                        container
                        alignItems="center"
                        spacing={1}
                        sx={{ paddingLeft: "9px" }}
                      >
                        <Grid item>
                          <FormLabel component="legend">GST</FormLabel>
                        </Grid>

                        <Grid item>
                          <FormControl component="fieldset">
                            <RadioGroup
                              aria-label="RdUrd"
                              name="RdUrd"
                              row
                              value={RdUrd}
                              // value={watch("RdUrd") || ''}
                              {...register("RdUrd")}
                              onChange={handleUrdChange}
                            >
                              <FormControlLabel
                                value="1"
                                control={
                                  <Radio
                                    sx={{
                                      "& .MuiSvgIcon-root": { fontSize: 18 },
                                    }}
                                  />
                                }
                                label="RD"
                                className="custom-textfield"
                                disabled={!AllButtonTextDisabled}
                              />
                              <FormControlLabel
                                value="2"
                                control={
                                  <Radio
                                    sx={{
                                      "& .MuiSvgIcon-root": { fontSize: 18 },
                                    }}
                                  />
                                }
                                label="URD"
                                className="custom-textfield"
                                disabled={!AllButtonTextDisabled}
                              />
                              <FormControlLabel
                                value="3"
                                control={
                                  <Radio
                                    sx={{
                                      "& .MuiSvgIcon-root": { fontSize: 18 },
                                    }}
                                  />
                                }
                                label="Compo"
                                className="custom-textfield"
                                disabled={!AllButtonTextDisabled}
                              />
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* <Grid container spacing={2} > */}
                </Box>
              </Grid>

              <Grid container spacing={1}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Alt Code"
                    name="PartyAltCode"
                    variant="filled"
                    className="custom-textfield"
                    disabled={!AllButtonTextDisabled}
                    value={watch("PartyAltCode") || ""}
                    {...register("PartyAltCode")}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label={
                      <span>
                        Abrv <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="PartyAbrv"
                    variant="filled"
                    className="custom-textfield"
                    disabled={!AllButtonTextDisabled}
                    value={watch("PartyAbrv") || ""}
                    {...register("PartyAbrv")}
                  />
                </Grid>

                <Grid item xs={12} md={4} className="form_field">
                  <FormControl
                    variant="filled"
                    fullWidth
                    className="custom-select"
                  >
                    <InputLabel id="partyType-select-label">
                      <span>
                        Party Type <span style={{ color: "red" }}>*</span>
                      </span>
                    </InputLabel>
                    <Select
                      labelId="partyType-select-label"
                      id="PartyCat"
                      name="PartyCat"
                      value={watch("PartyCat") || ""}
                      className="custom-textfield"
                      disabled={!AllButtonTextDisabled}
                      {...register("PartyCat")}
                    >
                      <MenuItem value={"SU"}>Supplier/Creditor</MenuItem>
                      <MenuItem value={"SP"}>Service Provider</MenuItem>
                      <MenuItem value={"BR"}>Broker</MenuItem>
                      <MenuItem value={"TR"}>Transporter</MenuItem>
                      <MenuItem value={"JB"}>Jobber</MenuItem>
                      <MenuItem value={"OT"}>Others</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <Box sx={{ display: "flex", gap: "1px" }}>
                <Grid container xs={10} md={8} spacing={0.5}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label={
                        <span>
                          PinCode <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="PinCode"
                      variant="filled"
                      className="custom-textfield"
                      disabled={!AllButtonTextDisabled}
                      value={watch("PinCode") || ""}
                      {...register("PinCode", {
                        onChange: handlePincodeChange,
                      })}
                      InputProps={{
                        endAdornment: AllButtonTextDisabled && (
                          <InputAdornment position="end">
                            <AddIcon
                              onClick={openNewTab}
                              style={{ cursor: "pointer" }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={6} className="form_field">
                    <FormControl
                      variant="filled"
                      fullWidth
                      className="custom-select"
                    >
                      <InputLabel id="areaName-select-label">
                        Area <span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      <Select
                        labelId="areaName-select-label"
                        id="PinId"
                        name="PinId"
                        value={watch("PinId") || ""}
                        className="custom-textfield"
                        disabled={!AllButtonTextDisabled}
                        {...register("PinId", { onChange: handlePinIdChange })}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 200, // Set the maximum height for the dropdown menu
                              overflow: "auto", // Allow scrolling if content exceeds the max height
                            },
                          },
                        }}
                      >
                        {PinCity.length > 0 ? (
                          PinCity.map((obj) => (
                            <MenuItem key={obj.Id} value={obj.Id}>
                              {obj.Name}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem value="" disabled>
                            No areas available
                          </MenuItem>
                        )}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="City"
                      name="City"
                      value={watch("City") || ""}
                      {...register("City")}
                      variant="filled"
                      className="custom-textfield"
                      disabled={!AllButtonTextDisabled}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="State"
                      name="State"
                      value={watch("State") || ""}
                      {...register("State")}
                      variant="filled"
                      className="custom-textfield"
                      disabled={!AllButtonTextDisabled}
                    />
                  </Grid>
                </Grid>

                <Grid container xs={12} md={4} spacing={0}>
                  <TextField
                    fullWidth
                    label="Address"
                    name="Addr"
                    multiline
                    rows={2}
                    variant="filled"
                    value={watch("Addr") || ""}
                    {...register("Addr")}
                    className="custom-textfield"
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "88px",
                        marginLeft: "7px",
                      },
                      "& .MuiInputBase-input": {
                        resize: "vertical",
                        marginTop: "10px",
                      },
                      "& .MuiFilledInput-root": {
                        "&:hover": {
                          backgroundColor: "transparent",
                        },
                        "&.Mui-focused": {
                          backgroundColor: "transparent",
                        },
                      },
                    }}
                    disabled={!AllButtonTextDisabled}
                  />
                </Grid>

                {/* <Grid container  xs={4} md={4}   sx={{border:1 , borderColor:"black"}}> 
                                      
                                </Grid> */}
              </Box>
            </Box>
          </Grid>
          <Grid item md={2} xs={12} display="flex" alignItems="center">
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              border="1px solid #ccc"
              borderRadius={1}
              width={150}
              height={170}
              overflow="hidden"
              position="relative"
              sx={{ cursor: "pointer", margin: "auto" }}
            >
              {/* {formData.photo ? (
                                <img
                                    src={formData.photo}
                                    alt="Logo"
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                    }}
                                />
                            ) : (
                                <Typography variant="body2" color="textSecondary">
                                    Photo
                                </Typography>
                            )}

                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleImageUpload}
                                style={{
                                    position: 'absolute',
                                    top: 0, left: 0, width: '100%', height: '100%',
                                    opacity: 0,
                                    cursor: 'pointer',
                                }}
                            /> */}
            </Box>
          </Grid>
        </Grid>

        <Grid container md={12} xs={12} sx={{ marginTop: "5px" }}>
          <Grid container md={5.3} xs={12} rowSpacing={0.5} columnSpacing={0.5}>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label={<span>GST NO <span style={{ color: 'red' }}>*</span></span>}
                name="GsttinNo"
                variant="filled"
                className="custom-textfield"
                disabled={!AllButtonTextDisabled}
                value={watch("GsttinNo") || ""}
                {...register("GsttinNo")}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="PAN No"
                name="PanNo"
                variant="filled"
                className="custom-textfield"
                disabled={!AllButtonTextDisabled}
                value={watch("PanNo") || ""}
                {...register("PanNo")}
              />
            </Grid>{" "}
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="TAN No"
                name="TanNo"
                variant="filled"
                className="custom-textfield"
                disabled={!AllButtonTextDisabled}
                value={watch("TanNo") || ""}
                {...register("TanNo")}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="IE Code"
                name="IeCode"
                variant="filled"
                className="custom-textfield"
                disabled={!AllButtonTextDisabled}
                value={watch("IeCode") || ""}
                {...register("IeCode")}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Tel No"
                name="TelNo"
                variant="filled"
                disabled={!AllButtonTextDisabled}
                className="custom-textfield"
                value={watch("TelNo") || ""}
                {...register("TelNo")}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Email"
                name="Email"
                variant="filled"
                className="custom-textfield"
                disabled={!AllButtonTextDisabled}
                value={watch("Email") || ""}
                {...register("Email")}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Contact Person"
                name="ContactPerson"
                variant="filled"
                className="custom-textfield"
                disabled={!AllButtonTextDisabled}
                value={watch("ContactPerson") || ""}
                {...register("ContactPerson")}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Mobile No"
                name="MobileNo"
                variant="filled"
                className="custom-textfield"
                disabled={!AllButtonTextDisabled}
                value={watch("MobileNo") || ""}
                {...register("MobileNo")}
              />
            </Grid>
          </Grid>

          <Grid
            container
            xs={12}
            md={5.3}
            spacing={0}
            sx={{ marginLeft: "0.3px" }}
          >
            <TextField
              fullWidth
              label="Work Address"
              name="WorkAdd"
              multiline
              rows={2}
              variant="filled"
              value={watch("WorkAdd") || ""}
              {...register("WorkAdd")}
              className="custom-textfield"
              sx={{
                "& .MuiInputBase-root": {
                  height: "89px",
                  marginLeft: "7px",
                },
                "& .MuiInputBase-input": {
                  resize: "vertical",
                  marginTop: "10px",
                },
                "& .MuiFilledInput-root": {
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                  "&.Mui-focused": {
                    backgroundColor: "transparent",
                  },
                },
              }}
              disabled={!AllButtonTextDisabled}
            />
          </Grid>
        </Grid>

        <Grid container md={12} xs={12} spacing={0.5}
          sx={{ paddingLeft: "5px", marginTop: "2px" }}
        >
          <Grid item xs={12} md={2.6}>
            <Grid container alignItems="center" spacing={0.5}>
              <Grid item>
                <FormLabel component="legend">Msme Reg</FormLabel>
              </Grid>

              <Grid item>
                <FormControl component="fieldset">
                  <RadioGroup
                    aria-label="MsmeFlag"
                    name="MsmeFlag"
                    row
                    value={MsmeFlag}
                    // value={watch("MsmeFlag") || ''}
                    {...register("MsmeFlag")}
                    onChange={handleClickFlag}
                  >
                    <FormControlLabel
                      value="Y"
                      control={
                        <Radio
                          sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }}
                        />
                      }
                      label="Yes"
                      className="custom-textfield"
                      disabled={!AllButtonTextDisabled}
                    />
                    <FormControlLabel
                      value="N"
                      control={
                        <Radio
                          sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }}
                        />
                      }
                      label="No"
                      className="custom-textfield"
                      disabled={!AllButtonTextDisabled}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={2.7}>
            <FormControl variant="filled" fullWidth className="custom-select">
              <InputLabel id="glControl-select-label">
                GL-Control A/C
              </InputLabel>
              <Select
                labelId="glControl-select-label"
                id="glControl-select"
                name="glControl"
                className="custom-textfield"
                disabled={!AllButtonTextDisabled}
                value={watch("AccledId") || ""}
                {...register("AccledId")}
              >
                <MenuItem value={1}>Sundry Creditors</MenuItem>
                <MenuItem value={2}>Sundry Debtors</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={2.7}>
            <TextField
              fullWidth
              label="MsmeNo"
              name="MsmeNo"
              variant="filled"
              className="custom-textfield"
              disabled={MsmeFlag !== "Y" || !AllButtonTextDisabled}
              value={watch("MsmeNo") || ""}
              {...register("MsmeNo")}
            />
          </Grid>
          <Grid item xs={12} md={2.7}>
            <FormControl variant="filled" fullWidth className="custom-select">
              <InputLabel id="areaName-select-label">MSME Act</InputLabel>
              <Select
                labelId="areaName-select-label"
                id="MsmeAct"
                name="MsmeAct"
                value={watch("MsmeAct") || ""}
                className="custom-textfield"
                disabled={MsmeFlag !== "Y" || !AllButtonTextDisabled}
                {...register("MsmeAct")}
              >
                <MenuItem value={"N"}>Not Register</MenuItem>
                <MenuItem value={"M"}>Mfr</MenuItem>
                <MenuItem value={"T"}>Trader</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid container md={12} xs={12} sx={{ marginTop: "5px" }}>
            <Grid container md={5.4} xs={12} spacing={0.5}>
              <Grid item xs={12} md={6}>
                <FormControl
                  variant="filled"
                  fullWidth
                  className="custom-select"
                >
                  <InputLabel id="areaName-select-label">MSME Trade</InputLabel>
                  <Select
                    labelId="areaName-select-label"
                    id="MsmeTr"
                    name="MsmeTr"
                    value={watch("MsmeTr") || ""}
                    className="custom-textfield"
                    disabled={MsmeFlag !== "Y" || !AllButtonTextDisabled}
                    {...register("MsmeTr")}
                  >
                    <MenuItem value={"N"}>Not Register</MenuItem>
                    <MenuItem value={"G"}>Goods</MenuItem>
                    <MenuItem value={"S"}>Service</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6}>
                <FormControl
                  variant="filled"
                  fullWidth
                  className="custom-select"
                >
                  <InputLabel id="areaName-select-label">MSME Class</InputLabel>
                  <Select
                    labelId="areaName-select-label"
                    id="MsmeClass"
                    name="MsmeClass"
                    value={watch("MsmeClass") || ""}
                    className="custom-textfield"
                    disabled={MsmeFlag !== "Y" || !AllButtonTextDisabled}
                    {...register("MsmeClass")}
                  >
                    <MenuItem value={"N"}>Not Register</MenuItem>
                    <MenuItem value={"M"}>Medium</MenuItem>
                    <MenuItem value={"M"}>Micro/Small</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6}>
                {/* <FormControl variant="filled" fullWidth className="custom-select">
                                    <InputLabel id="VndClsId-select-label">Class</InputLabel>
                                    <Select
                                        labelId="VndClsId-select-label"
                                        id="VndClsId"
                                        name="VndClsId"
                                        value={watch('VndClsId') || ""}
                                        className="custom-textfield"
                                        disabled={!AllButtonTextDisabled}
                                        {...register('VndClsId')}
                                    >
                                        <MenuItem value={""}></MenuItem>
                                    </Select>
                                </FormControl> */}
                <CustomAutocomplete
                  options={ClassDrp}
                  id="VndClsId-autocomplete"
                  name="VndClsId"
                  label="Class"
                  value={
                    ClassDrp.find((obj) => obj.Id === watch("VndClsId")) || null
                  }
                  {...register("VndClsId")}
                  disabled={!AllButtonTextDisabled}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                {/* <FormControl variant="filled" fullWidth className="custom-select">
                                    <InputLabel id="VndRtgId-select-label">Rating</InputLabel>
                                    <Select
                                        labelId="VndRtgId-select-label"
                                        id="VndRtgId"
                                        name="VndRtgId"
                                        value={watch('VndRtgId') || ""}
                                        className="custom-textfield"
                                        disabled={!AllButtonTextDisabled}
                                        {...register('VndRtgId')}
                                    >
                                        <MenuItem value={""}></MenuItem>
                                    </Select>
                                </FormControl> */}
                <CustomAutocomplete
                  options={RatingDrp}
                  id="VndRtgId-autocomplete"
                  name="VndRtgId"
                  label="Rating"
                  value={
                    RatingDrp.find((obj) => obj.Id === watch("VndRtgId")) ||
                    null
                  }
                  {...register("VndRtgId")}
                  disabled={!AllButtonTextDisabled}
                />
              </Grid>
            </Grid>

            <Grid item xs={12} md={4} spacing={0} sx={{ marginLeft: "0.3px" }}>
              <TextField
                fullWidth
                label="Remark"
                name="Remark"
                multiline
                rows={2}
                variant="filled"
                className="custom-textfield"
                value={watch("Remark") || ""}
                {...register("Remark")}
                sx={{
                  width: "340px",
                  "& .MuiInputBase-root": {
                    height: "86px",
                    marginLeft: "7px",
                  },
                  "& .MuiInputBase-input": {
                    resize: "vertical",
                  },
                  "& .MuiFilledInput-root": {
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                    "&.Mui-focused": {
                      backgroundColor: "transparent",
                    },
                  },
                }}
                disabled={!AllButtonTextDisabled}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={!AllButtonTextDisabled}
                      {...register("Status")}
                      checked={localStatus === "1"}
                      onChange={handleChangeStatus}
                    />
                  }
                  label="Status"
                />
              </FormGroup>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        className="form_button"
        sx={{ position: "relative", top: 10 }}
      >
        <Button
          variant="contained"
          size="small"
          sx={{
            mr: 1,
            background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
          }}
          disabled={!AllButtonTextDisabled}
          onClick={handleClickNext}
        >
          Next
        </Button>
        <Button
          variant="contained"
          size="small"
          sx={{
            mr: 1,
            background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
          }}
          disabled={!AllButtonTextDisabled}
          onClick={handleClickCancel}
        >
          Cancel
        </Button>
      </Grid>
    </>
  );
};

export default PartyStepper1;
